import React from 'react';

const EmptyLeaderboardIcon = () => (
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M59.5906 43.2369L60.9822 45.6223C60.6505 45.6122 60.3205 45.6071 59.9956 45.6071H59.9808C59.4108 45.6071 58.8425 45.6071 58.2281 45.6504C51.3899 45.9764 45.0109 48.2128 39.6687 51.8176L19.5858 15.3438C19.2448 14.6829 19.248 13.8869 19.6083 13.2381C20.0178 12.5754 20.6959 12.1904 21.4539 12.1904H40.2039C40.9646 12.1904 41.6448 12.5782 42.0538 13.2451L59.5901 43.236L59.5906 43.2369Z"
      fill="#FD8F01"
      stroke="#052A75"
      style={{ fill: '#FD8F01', fillOpacity: 1, stroke: '#052A75', strokeOpacity: 1 }}
      strokeWidth="2"
    />
    <path
      d="M100.404 15.3439L80.3235 51.8131C77.6695 50.0066 74.7652 48.5586 71.6665 47.525L65.1444 36.3443L77.9047 13.3106C78.3208 12.604 79.0411 12.1904 79.7858 12.1904H98.5358C99.2938 12.1904 99.9719 12.5754 100.381 13.2381C100.742 13.8869 100.745 14.683 100.404 15.3439Z"
      fill="#FD8F01"
      stroke="#052A75"
      style={{ fill: '#FD8F01', fillOpacity: 1, stroke: '#052A75', strokeOpacity: 1 }}
      strokeWidth="2"
    />
    <path
      d="M55.4937 75.3208C55.4937 77.6435 54.5254 79.5265 53.3309 79.5265C52.1363 79.5265 51.168 77.6435 51.168 75.3208C51.168 72.9982 52.1363 71.1152 53.3309 71.1152C54.5254 71.1152 55.4937 72.9982 55.4937 75.3208Z"
      fill="#FDCB50"
      style={{ fill: '#FDCB50', fillOpacity: 1 }}
    />
    <path
      d="M69.4332 75.3208C69.4332 77.6435 68.4648 79.5265 67.2703 79.5265C66.0758 79.5265 65.1074 77.6435 65.1074 75.3208C65.1074 72.9982 66.0758 71.1152 67.2703 71.1152C68.4648 71.1152 69.4332 72.9982 69.4332 75.3208Z"
      fill="#FDCB50"
      style={{ fill: '#FDCB50', fillOpacity: 1 }}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.3773 89.4554C60.1195 87.1494 56.0369 88.6407 54.7442 89.5665C54.4421 89.7828 54.0219 89.7134 53.8055 89.4113C53.5892 89.1093 53.6587 88.689 53.9608 88.4727C55.632 87.2757 60.2169 85.7229 65.9177 88.2233C66.258 88.3725 66.4128 88.7693 66.2636 89.1096C66.1144 89.4498 65.7176 89.6047 65.3773 89.4554Z"
      fill="#FD8F01"
      style={{ fill: '#FD8F01', fillOpacity: 1 }}
    />
    <path
      d="M59.9941 107.467C75.1968 107.467 87.5211 95.1431 87.5211 79.9404C87.5211 64.7377 75.1968 52.4135 59.9941 52.4135C44.7914 52.4135 32.4672 64.7377 32.4672 79.9404C32.4672 95.1431 44.7914 107.467 59.9941 107.467ZM80.3166 79.9404C80.3166 91.1642 71.2179 100.263 59.9941 100.263C48.7703 100.263 39.6717 91.1642 39.6717 79.9404C39.6717 68.7166 48.7703 59.6179 59.9941 59.6179C71.2179 59.6179 80.3166 68.7166 80.3166 79.9404Z"
      fill="#FDCB50"
      stroke="#052A75"
      style={{ fill: '#FDCB50', fillOpacity: 1, stroke: '#052A75', strokeOpacity: 1 }}
      strokeWidth="2.55385"
    />
  </svg>
);

export default EmptyLeaderboardIcon;
